import { useChatContext } from './ChatContext';

const useExpandedMessageTaffiIds = () => {
    const { expandedMessageTaffiIds, addExpandedMessageTaffiId, isExpandedMessage } = useChatContext();
    return { expandedMessageTaffiIds, addExpandedMessageTaffiId, isExpandedMessage };
};

export default useExpandedMessageTaffiIds;
